function productcarousel(){
  var product_carousel = document.querySelectorAll('.product-carousel-slider');
  if($(window).width()>991){
    product_carousel.forEach(function(carouselClass){
      var $carousel = new Flickity(carouselClass, {
        prevNextButtons: false,
        autoPlay: 2000,
        wrapAround: true
      });
    });
  }else{
    product_carousel.forEach(function(carouselClass){
      var $carousel = new Flickity(carouselClass, {
        prevNextButtons: false,
        wrapAround: true,
        cellAlign: 'left'
      });
    });
  }
  $(window).scroll(function(){
    var docViewTop = $(window).scrollTop();
    var windowhalfheight = ($(window).height() / 1);
    var docViewBottom = docViewTop + windowhalfheight;
    $('.section-product-carousel').each(function(e){
      var elemTop = $(this).offset().top;
      if(elemTop < docViewBottom){  
        $(this).addClass('active-carousel');
      }
    });    
  });
}
productcarousel();